import { ReactComponent as Logo } from '../../engene-logo.svg';
const EnegeneLogo = ({
  onClick,
  width,
  height,
}: {
  onClick?: () => void;
  width?: number;
  height?: number;
}) => {
  return (
    <div>
      {/* Logo is an actual React component */}
      <Logo width={width} height={height} onClick={onClick} />
    </div>
  );
};
export default EnegeneLogo;
